import type { JSX } from 'react';

import { CreateMasterProjectButton } from 'features/master';
import { ProjectSwitcher } from 'features/projects';

import { SidebarHeader } from '@/components/ui/sidebar';

const SidebarBrand = (): JSX.Element => (
  <SidebarHeader>
    <div className="flex items-center gap-2 px-2 py-1 group-data-[collapsible=icon]:justify-center group-data-[collapsible=icon]:px-0">
      <img alt="Lidz" className="size-12 shrink-0 group-data-[collapsible=icon]:size-10" src="/logo-white.svg" />
      <div className="flex min-w-0 flex-col group-data-[collapsible=icon]:hidden">
        <p className="text-xs font-medium uppercase tracking-widest text-brand-turquoise font-body">Lidz</p>
        <h1 className="m-0 font-display text-lg font-medium text-white">Ops Center</h1>
      </div>
    </div>
    <CreateMasterProjectButton
      className="w-full group-data-[collapsible=icon]:px-0 group-data-[collapsible=icon]:justify-center"
      labelClassName="group-data-[collapsible=icon]:hidden"
    />
    <ProjectSwitcher />
  </SidebarHeader>
);

export default SidebarBrand;
